import { useEffect } from "react";
import useResponse from "../../hooks/useResponse";
import { showManualContextualLoader } from "../../utils/contextualLoaderTrigger";

export default function Stepper() {
  const { handleStep } = useResponse();

  useEffect(() => {
    showManualContextualLoader("Please wait...", 500);
    handleStep();
  }, []);

  return null
}
